import { AUTH_SESSION_KEYS } from "@/constants/authFlowKeys";
import { authSessionStorage } from "@services/auth/authStorage";

// Consecutive failed callbacks in this tab. With a live provider session each
// automatic restart fails the same way, so without a cap it redirects forever.

const STORAGE_KEY = AUTH_SESSION_KEYS.CALLBACK_FAILURE_COUNT;

// Automatic restarts allowed before the callback stops and asks the user.
export const MAX_AUTOMATIC_CALLBACK_RESTARTS = 1;

// Records one more failure and returns the new count.
export const recordCallbackFailure = () => {
  const count = (Number(authSessionStorage.get(STORAGE_KEY)) || 0) + 1;
  // An unpersisted count resets on every reload, so the cap could never trip.
  return authSessionStorage.set(STORAGE_KEY, String(count))
    ? count
    : Number.POSITIVE_INFINITY;
};

export const shouldStopRestartingSignIn = (count) =>
  count > MAX_AUTOMATIC_CALLBACK_RESTARTS;

// Called on a completed sign-in and when the user deliberately retries.
export const clearCallbackFailures = () => {
  authSessionStorage.remove(STORAGE_KEY);
};
